// extracted by mini-css-extract-plugin
export default {"markdown":"e51bd4bb57e2"};